import { useEffect, useRef } from 'react'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

function DeletePostModal({ open, onClose, onConfirm }: Props) {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (!ref.current) return
    if (open) {
      ref.current.showModal()
    } else {
      ref.current.close()
    }
  }, [open])

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <dialog
      ref={ref}
      id='delete-post-modal'
      className='modal'
      onCancel={e => {
        e.preventDefault()
        handleClose()
      }}>
      <div className='modal-box'>
        <h3 className='font-bold text-lg'>Limpar tudo</h3>
        <p className='py-4'>Todos os itens e estilos serão removidos permanentemente.</p>
        <div className='modal-action'>
          <form className='flex gap-2' method='dialog'>
            <button className='btn btn-error' onClick={onConfirm}>
              Confirmar
            </button>
            <button className='btn' onClick={handleClose}>
              Cancelar
            </button>
          </form>
        </div>
      </div>
      <label className='modal-backdrop' htmlFor='delete-post-modal' onClick={handleClose}>
        Cancelar
      </label>
    </dialog>
  )
}

export default DeletePostModal
